/** @jsx jsx */
import { jsx, Interpolation } from '@emotion/core'
import { FunctionComponent, InputHTMLAttributes, SelectHTMLAttributes } from 'react'
import { styles } from './styles'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const Input: FunctionComponent<InputProps> = ({ css, ...props }) => (
  <input css={[styles.input, ...[css].flat()] as Interpolation} {...props} />
)

interface InputWithLabelProps extends InputProps {
  label: string
}

export const InputWithLabel: FunctionComponent<InputWithLabelProps> = ({
  id,
  label,
  css,
  required,
  disabled,
  ...props
}) => (
  <div css={styles.withLabel.container}>
    <label css={styles.withLabel.label} htmlFor={id}>
      {label} {required && <span css={styles.withLabel.required}>*</span>}
    </label>
    <Input
      css={
        [
          styles.withLabel.input,
          disabled && styles.disabled,
          ...[css].flat(),
        ] as Interpolation
      }
      id={id}
      required={required}
      disabled={disabled}
      {...props}
    />
  </div>
)

// @ts-ignore
interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: { name: string | number; value: string | number }[]
  selected: string | number
  onChange: (value: string | number) => any
}

export const Select: FunctionComponent<SelectProps> = ({
  options,
  selected,
  onChange,
  placeholder,
  ...props
}) => (
  <select
    css={[styles.input, styles.select.container, selected && styles.select.selected]}
    value={selected}
    onChange={(e) => onChange(e.target.value)}
    {...props}
  >
    <option value="" disabled>
      {placeholder}
    </option>

    {options.map(({ name, value }) => (
      <option value={value} key={value}>
        {name}
      </option>
    ))}
  </select>
)

interface SelectWithLabelProps extends SelectProps {
  label: string
}

export const SelectWithLabel: FunctionComponent<SelectWithLabelProps> = ({
  id,
  label,
  css,
  required,
  ...props
}) => (
  <div css={styles.withLabel.container}>
    <label css={styles.withLabel.label} htmlFor={id}>
      {label} {required && <span css={styles.withLabel.required}>*</span>}
    </label>
    <Select
      css={[styles.withLabel.input, ...[css].flat()] as Interpolation}
      id={id}
      required={required}
      {...props}
    />
  </div>
)
